import { inject, Injectable } from '@angular/core';
import { Platform } from '@ionic/angular/standalone';
import { environment } from 'src/environments/environment';
import { Capacitor } from '@capacitor/core';

@Injectable({
  providedIn: 'root',
})
export class CustomisationService {
  private platform = inject(Platform);

  isChatEnabled(): boolean {
    return !(environment.telegram || (this.platform.is('capacitor') && this.platform.is('ios')));
  }

  isLoginEnabled(): boolean {
    return !environment.telegram;
  }

  isNicknameEditEnabled(): boolean {
    return !environment.telegram;
  }

  isDangerZoneEnabled(): boolean {
    return !environment.telegram;
  }

  isDownloadAppEnabled(): boolean {
    return this.platform.is('mobile') && !Capacitor.isNativePlatform();
  }

  isInviteMenuButtonEnabled(): boolean {
    return environment.telegram;
  }
}
